import Axios from 'axios';

export const parsePastedVideoEmbedUrl = async (
  videoURL: string,
): Promise<string | undefined> => {
  let videoCode = '';
  const videoId = videoURL;

  // YouTube

  // if allready correct format
  if (videoId.includes('youtube-nocookie.com')) {
    return videoId;
  }

  if (
    videoURL.startsWith('https://www.youtube.com/shorts') ||
    videoURL.startsWith('https://youtube.com/shorts')
  ) {
    // https://youtube.com/shorts/rNt2RFQTXoA?feature=share

    const urlParts = videoURL.split('/');
    const id = urlParts[4];
    return `https://www.youtube-nocookie.com/embed/${id}`;
  }

  if (videoId.includes('youtube.com') || videoId.includes('youtu.be')) {
    let regex = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/;
    let timestampUrl = '';
    if (videoId.match(regex)) {
      const splitUrl = videoId.split(/[/?&]+/);
      // get timestamp
      if (videoId.includes('t=')) {
        let timestamp = splitUrl.find(t => t.includes('t='));
        timestamp = timestamp?.split(/[=s]/)[1];
        timestampUrl = `?start=${timestamp}`;
      }
      if (videoId.includes('watch?v=')) {
        videoCode = splitUrl[3].split('=')[1];
      } else {
        videoCode = splitUrl[2];
      }
      regex = /[a-zA-Z0-9\-_]{11}/;
      if (videoCode.match(regex)) {
        return `https://www.youtube-nocookie.com/embed/${videoCode}${timestampUrl}`;
      }
    }
    return undefined;
  }

  // canva
  if (videoURL.startsWith('https://www.canva.com/')) {
    const urlParts = videoURL.split('/');
    const designId = urlParts[4];
    return `https://www.canva.com/design/${designId}/view?embed`;
  }

  if (isNrkUrl(videoURL)) {
    return videoURL;
  }

  if (isNrkPasteUrl(videoURL)) {
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(videoURL, 'text/html');

    const elements = htmlDoc.getElementsByClassName(NRKEmbedConfig.className);
    if (elements.length === 0) return undefined;
    const relatedDiv = elements[0] as HTMLDivElement;

    const nrkId = relatedDiv.dataset.nrkId;
    if (!nrkId) return undefined;
    return `nrk://${nrkId}`;
  }

  const nrkMatcher = isNrkMediaIdPasteUrl(videoURL);
  if (nrkMatcher.success && nrkMatcher.mediaId) {
    const nrkId = await NRKAPI.fetchNrkIdFromNrkMediaId(nrkMatcher.mediaId);
    if (!nrkId) return undefined;
    return `nrk://${nrkId}`;
  }

  if (videoURL.startsWith('https://vimeo.com/')) {
    const urlParts = videoURL.split('/');
    const designId = urlParts[3];
    return `https://player.vimeo.com/video/${designId}?h=0a7f520d09&title=0&byline=0&portrait=0`;
  }

  /*
  *<iframe src="https://drive.google.com/file/d/1189hIE5ZmwJ9UWqcZRD1gBmpR-NnL6vy/preview" width="640" height="480"></iframe>
  Support screencastify
  */
  if (videoURL.startsWith('<iframe src="https://drive.google.com/file/d')) {
    const urlParts = videoURL.split('/');
    const videoId = urlParts[5];
    return `https://drive.google.com/file/d/${videoId}/preview`;
  }

  // Support embedding videos from google drive
  if (videoURL.startsWith('https://drive.google.com/file/d')) {
    const urlParts = videoURL.split('/');
    const videoId = urlParts[5];
    return `https://drive.google.com/file/d/${videoId}/preview`;
  }

  return undefined;
};

export const NRKAPI = {
  openNrkAPIBaseUrl: 'https://nrkno-skole-prod.kube.nrk.no/skole/api/media',
  fetchNrkMedia: async (mediaId: string) => {
    const res = await Axios.get<{ mId: string; psId: string }>(
      `${NRKAPI.openNrkAPIBaseUrl}/${mediaId}`,
    );
    return res.data;
  },
  fetchNrkIdFromNrkMediaId: async (mediaId: string) => {
    try {
      const media = await NRKAPI.fetchNrkMedia(mediaId);
      return media.psId;
    } catch (e) {
      return undefined;
    }
  },
};

export const createNrkSaveUrl = (nrkId: string) => `nrk://${nrkId}`;

export const isNrkUrl = (url: string) => url.startsWith('nrk://');

export const getNrkIdFromNrkUrl = (url: string) => url.split('nrk://')[1];

export const NRKEmbedConfig = {
  className: 'nrk-video',
  dataAttribute: 'data-nrk-id',
  scriptUrl: 'https://static.nrk.no/ludo/latest/video-embed.js',
};

const isNrkPasteUrl = (pastedUrl: string) => {
  // example: <div class="nrk-video" data-nrk-id="8ffe33fd-b564-4865-a558-35eceb2457f1">&nbsp;</div><script src="https://static.nrk.no/ludo/latest/video-embed.js"></script>
  return (
    pastedUrl.includes(NRKEmbedConfig.className) &&
    pastedUrl.includes(NRKEmbedConfig.dataAttribute) &&
    pastedUrl.includes(NRKEmbedConfig.scriptUrl)
  );
};

const isNrkMediaIdPasteUrl = (pastedUrl: string) => {
  const skoleDelingRegex = new RegExp(/https:\/\/www.nrk.no\/skole-deling\/([0-9]*)/g);
  const browserUrlCopyRegex = new RegExp(/https:\/\/www.nrk.no\/skole/g);
  const skoleDelingRes = skoleDelingRegex.exec(pastedUrl);
  const browserUrlCopyRes = browserUrlCopyRegex.exec(pastedUrl);

  if (skoleDelingRes !== null) {
    return {
      mediaId: skoleDelingRes[1],
      success: true,
    };
  }

  if (browserUrlCopyRes !== null) {
    const url = new URL(pastedUrl);
    const query = new URLSearchParams(url.search);
    const id = query.get('mediaId');
    if (id !== null) {
      return {
        mediaId: id,
        success: true,
      };
    }
  }

  return {
    success: false,
  };
};
